import React from 'react'
import {FeatureAppPosizioniAperteDependencies} from './'

export const FeatureServicesContext = React.createContext<
    FeatureAppPosizioniAperteDependencies | undefined
>(undefined)

export function useFeatureServices(): FeatureAppPosizioniAperteDependencies {
    const featureServices = React.useContext(FeatureServicesContext)

    if (!featureServices) {
        throw new Error('No featureServices context value was provided.')
    }

    return featureServices
}
